module.exports = __webpack_public_path__ + "img/foto-3x4.fc09d8b6.png";